// Hour analysis
// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import EnergyTreeNodeHourAnalysisPage from '@/features/energyxplorer/components/analysis/EnergyTreeNodeHourAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/hour-analysis',
)({
  component: EnergyTreeNodeHourAnalysisPage,
  staticData: { crumb: 'energyxplorer:app_bar.energy_analysis_hour' },
});
